export default __webpack_public_path__ + "static/media/Track Critical Software Activity Logs.feb8b047.png";